import { Store } from 'vuex'

import registerStoreModule from 'modules/common/common-methods/register-store-module'
import { PRODUCT_SEARCH_VIEW_NAME, PRODUCT_SEARCH_VIEW } from './store'

export default (http, store: Store<any>): void => {
  registerStoreModule({
    name: PRODUCT_SEARCH_VIEW_NAME,
    storeModule: PRODUCT_SEARCH_VIEW,
    http,
    store
  })
}